import { Component } from "react"
import "./coupon.scss"

class Coupon extends Component {
  render () {
    // 2021.6.15 13:00~ 表示, 2021.8.1 00:00 非表示
    const now = new Date()
    const isCouponShown = new Date('2021/06/15 13:00:00+09:00') <= now && now < new Date('2021/08/01 00:00:00+09:00')

    if (!isCouponShown) {
      return null
    }

    return (
      <section styleName="coupon" >
        <div styleName="content">
          <h2>期間限定クーポン配布中</h2>
          <p>
            <span>5泊以上の予約で</span>
            <span>5,000円 OFF!!</span>
          </p>
          <div style={{textAlign: "center"}}>
            {this.props.isShowCode
              ? <span styleName="coupon-code">LONGSTAY5K</span>
              : <button styleName="btn" id={this.props.id} onClick={this.props.handleClick}>クーポンコードを表示</button>
            }
          </div>
          <div styleName="conditions">
            <dl>
              <dt>予約可能期間: </dt>
              <dd>2021年6月15日 00:00 ～ 2021年7月31日 23:59</dd>
            </dl>
            <dl>
              <dt>宿泊可能期間: </dt>
              <dd>2021年6月16日 チェックイン ～ 2021年8月31日 チェックアウト</dd>
            </dl>
            <dl>
              <dt>利用条件: </dt>
              <dd>5泊以上、50,000円(税込)以上の予約料金</dd>
            </dl>
            <dl>
              <dt>利用方法: </dt>
              <dd>予約内容確認画面でクーポンコードを入力、適用してください</dd>
            </dl>
          </div>
        </div>
      </section>
    )
  }
}

export default Coupon
